import styled from 'styled-components'
import { alpha } from '@mui/material/styles'
import { ReviewDetails } from '../styled'

export const ReviewSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
  color: ${({ theme }) => theme.palette.colors.text};
  overflow-wrap: anywhere;

  > p { margin: 0; }
`

export const ReviewChoices = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  > h3 { margin: 0; font-size: 16px; }
`

export const ReviewChoice = styled(ReviewDetails).attrs({ as: 'button', type: 'button' })`
  width: 100%;
  font: inherit;
  text-align: left;
  cursor: pointer;
  background: ${({ theme, $selected }) => $selected
    ? `linear-gradient(${alpha(theme.palette.blue.main, 0.16)}, ${alpha(theme.palette.blue.main, 0.16)}), ${theme.palette.colors.surfaceElevated}`
    : theme.palette.colors.surfaceElevated};
  border-color: ${({ theme, $selected }) => $selected ? theme.palette.blue.main : theme.palette.colors.borderSoft};
  color: ${({ theme }) => theme.palette.colors.text};
  transition: background 180ms ease, border-color 180ms ease;

  strong { color: inherit; }
  span { color: ${({ theme }) => theme.palette.colors.subdued}; }
  &:hover:not(:disabled) { border-color: ${({ theme }) => theme.palette.blue.main}; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.palette.blue.main}; outline-offset: 2px; }
  &:disabled { cursor: not-allowed; }
  @media (prefers-reduced-motion: reduce) { transition: none; }
`
